import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

export default function CampaignSearchInput({ value, onChange, placeholder }) {
  return (
    <div className="relative w-[300px] shrink-0">
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full bg-white border border-border-lines rounded-full pl-9 pr-3 py-2 text-sm outline-none"
        placeholder={placeholder}
      />
      <UIcons.UilSearch className="text-placeholder absolute top-1/2 -translate-y-1/2 left-3" size={16} />
    </div>
  )
}
